import logo from '../logo.svg';
import { Typography, Paper, AppBar, Button, Box, Card, CardActions, CardContent, CardMedia, CssBaseline, Grid, Link, Toolbar, Container } from '@mui/material';
import { HashLink } from 'react-router-hash-link';
import ResponsiveAppBar from './ResponsiveAppBar';
import Contactform from './Contactform';
import Footer from "./Footer";
import '../App.css';

const Imprint = () => {
  return (
    <div className="App">

<ResponsiveAppBar />

      <main>

        <Container maxWidth="lg" className="subPageContainer">
          <Typography variant='h1' className='sectionTitle'>Vorsorge treffen</Typography>

          <Box className='subpageBodyBox'>
            <Typography variant='body1' className='sectionText textTwoColumns'>
            Wer seine Angelegenheiten nicht mehr selbst regeln kann, bekommt einen Betreuer zur Seite gestellt. Der Betreuer hat Zugriff auf das Vermögen der betreuten Person. Betreuer soll nach dem Gesetz möglichst ein Angehöriger der betreuten Person sein. Gibt es keine geeigneten Angehörigen, bestellt das Amtsgericht einen Berufsbetreuer. Für bestimmte Rechtsgeschäfte muss der Betreuer eine Genehmigung durch das Betreuungsgericht einholen. Dieser Prozess ist sehr aufwendig und kostet Geld. Daher empfiehlt es sich, bei einem Notar eine General- und Vorsorgevollmacht zu errichten. Darin legt der Vollmachtgeber fest, welche Personen ihn vertreten dürfen, wenn er später betreuungsbedürftig werden sollte. Diese Vollmacht kann der Bevollmächtigte für alle Arten von Rechtsgeschäften nutzen. Eine gerichtliche Genehmigung braucht er nicht einzuholen. Der Vollmachtgeber kann die Vollmacht jederzeit widerrufen. Gehört dem Vollmachtgeber eine Immobilie oder ein Unternehmen, muss er die Vollmacht zwingend vor einem Notar errichten. Denn nur mittels einer notariellen Vollmacht kann der Bevollmächtigte die Immobilie verkaufen, ein Darlehen für den Vollmachtgeber aufnehmen und wichtige Entscheidungen in einem Unternehmen treffen. <br /><br />
            Häufig errichtet der Vollmachtgeber zugleich eine Patientenverfügung. Darin legt der Vollmachtgeber fest, wie er behandelt werden möchte, wenn er sterben wird. Die Patientenverfügung entlastet insbesondere die Angehörigen des Sterbenden, wenn sie eine Entscheidung über die weitere Behandlung treffen müssen.
            </Typography>
            <Typography variant='body1' className='sectionText'>
          
            </Typography>

            <Button className='btnSecondary'><HashLink smooth to="#">Vorsorgevollmacht und Patientenverfügung online abwickeln</HashLink></Button>
          </Box>
          
        </Container>


<Box className="section bannergrey" id="kontakt">
          <Container maxWidth="lg" className="container" id="kontakt">
            <Box className="kontaktGrid">
              <Box className="kontaktLeftSide">
                <Typography variant='h2' className='sectionTitle white'>
                  Sie haben Fragen?  <br />
                  Wir stehen Ihnen gerne zur Verfügung und beantworten Ihr Anliegen in Kürze.
                </Typography>
                <Typography variant='body1' paragraph className='whiteText'>
                  Harbecke & Thelen Notare<br />
                  Holzgasse 29 - 33<br />
                  Siegburg 53721<br />
                </Typography>
              </Box>
              <Contactform />
            </Box>
          </Container>
        </Box>

        
      </main >
      <Footer />
    </div >
  );
}

export default Imprint;